import React, { Component } from 'react';
import SFMic from './Mic/Mic';
import InputSuggestions from './Predsearch';
import {
	CurrentLanguageContext,
	InternationalizationContext,
} from '../../../../src/Utils/Contexts';
import ClickOutside from '../ClickOutside/index';
import PersistanceMenu from './Persistance Menu/index';
import IconButton from '../Buttons/IconButton/IconButton';
import styled from 'styled-components';
import Snackbar from '../Snackbar/Snackbar';
import { TString } from '../Response/Utils';
import {
	Chats,
	Feedback,
	FileIcon,
	GetinTouch,
	GetinTouchFilled,
	Home,
	HomeFilled,
	SmileyIcon,
} from '../../../../assets/imgs/icons/index';
import { FooterHolder } from '../WelcomeScreen/styles/theme1/theme1.styled';
import Input from '../../FlyfishComponents/Input';

let Mic = SFMic.Mic;
const styleVars = getComputedStyle(document.querySelector(':root'));
let allowTabFocus = true;

const ChatInputHolder = styled.div`
	.sf-chatinput[contenteditable='true']:empty:before {
		color: ${(props: any) => {
			return props.foreground ? props.foreground + '99' : '';
		}} !important;
	}
`;
//change here padding
const ChatInputDIV = styled.div`
	&.ff-chatinput-block {
		width: 100%;
		padding: 0 24px;
		max-width: calc(1065px + 48px);
		&.homescreen {
			justify-content: center;
			position: absolute;
			bottom: 0;
			z-index: 99;
		}
		& > .ff-chatInput-content {
			padding-top: 10px;
		}
		&.monaco,
		&.E-commerce.Chat {
			display: flex;
			gap: 10px;
			padding-right: ${(props) => (props.cartExist ? 'calc(14% - 30px)' : '')};
			@media (min-width: 320px) and (max-width: 480px) {
				padding: 0 6% !important;
			}

			& > .ff-chatInput-content {
				width: 100%;
			}
			& > svg {
				position: relative;
				top: 4px;
				width: 20px;
				cursor: pointer;
			}
		}
		& #sfChatInputMain {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 6.5px 12px 6.5px 16px;
			border-radius: 20px;
			outline: solid 1.5px var(--black-20) !important;
			// width: 75vw;
			color: #222020;
			&.focused-input {
				outline: 2px solid var(--selectedColor) !important;
			}
			&.monaco,
			&.E-commerce.Chat {
				border-radius: 0;
				margin-top: 20px;
				height: 45px;
			}

			&.iconSpace {
				border: 1px solid;
			}
			& > #chatInput {
				width: 97%;
				cursor: text;
				font-size: var(--fontSize) !important;
				border: none;
				outline: none;
				&[contenteditable='true']:empty:before {
					content: attr(placeholder);
					color: rgba(0, 0, 0, 0.6);
					font-weight: 500;
				}

				&::after {
					visibility: hidden !important;
				}
				&::placeholder {
					color: rgba(0, 0, 0, 0.6) !important;
				}
			}
			& #send-msg {
				display: flex;
				cursor: pointer;
			}
		}
	}
`;

interface Props {
	enableGetInTouch: boolean;
	chatInput?: string;
	handleInput?: Function;
	handleFocus?: Function;
	handleKeyUp?: Function;
	handleSubmit?: Function;
	isSpeech?: boolean;
	predSearchToggle?: boolean;
	predSearchResponse?: any;
	togglePredSearch?: Function;
	assignPredSearchQues?: Function;
	isChatInputDisabled?: boolean;
	toggleSpeakingFunctionality?: Function;
	stopSpeaking?: Function;
	data;
	suggestions?: any;
	snackBarMessage?: string;
	languages?: string;
	botId?: string;
	language_codes?: {
		[k: string]: string;
	};
	setLangListVisibility?: (visibility: boolean) => void;
	isChatBodyVisible?: boolean;
	isChatInputHidden?: boolean;
	formChatInputHidden: boolean;
	isdisableInput?: boolean;
	persistantMenuEnabled?: string;
	persistantMenuData?: any;
	quickLinks?: any;
	langCode: string;
	voiceResponse: boolean;
	isShowSameItemsMenuEnabled: string;
	getLoader: Function;
	channel?: string;
	toggleLang?: Function;
	showWelcomeScreen?: boolean;
	HideWelcomeScreen: Function;
	changeScreen: Function;
	currentScreen: string;
	colorScale: string[];
	colorMode: string;
	changeInput: Function;
	submitchanges: Function;
	disableGetInTouch?: boolean;
	showFeedbackPopup: boolean;
	selectedTheme: string;
	showMonacoCart?: boolean;
	updateMonacoCartStatus?: Function;
	cartExist;
	enableVoiceModal;
	voiceText;
}
interface State {
	indexOfPredSearchElem: number;
	isLanguageListVisible: boolean;
	languages: { languageName: string; languageCode: string }[];
	showMenu: boolean;
	showSnackBar: boolean;
	message: string;
	langInfo: {
		visible: boolean;
		langName: string;
	};
	showInputList: boolean;
	isCursor: boolean;
	showMenuIcon: boolean;
	inputChange: boolean;
	sortedList: [];
	count: number;
	isAutoList: boolean;
	addFocus: boolean;
	queryText: string;
}
class ChatInput extends Component<Props, State> {
	inputRef: React.MutableRefObject<any> = React.createRef();
	myRef: React.MutableRefObject<any> = React.createRef();

	state: State = {
		indexOfPredSearchElem: -1,
		isLanguageListVisible: false,
		languages: [],
		showMenu: false,
		showSnackBar: false,
		message: '',
		langInfo: {
			langName: '',
			visible: false,
		},
		showInputList: true,
		isCursor: false,
		showMenuIcon: false,
		inputChange: false,
		sortedList: [],
		count: 0,
		isAutoList: false,
		addFocus: false,
		queryText: '',
	};
	handleSubmit() {
		//Imitate onKeyUp == enter Event (new Event has no support in IE)
		//A very bad way to do Event
		this.props.handleKeyUp.call(this, { keyCode: 13 });
	}
	onDropHandler(val: string) {
		this.inputRef.current.focus();
		this.props.handleInput({ target: { value: val } });
	}
	onKeyUpHandler = (ev: any) => {
		ev.stopPropagation();
		let itemList = this.getAutoList().length > 0 ? true : false;
		let autoSuggest: any;
		autoSuggest = this.getAutoList();
		if (itemList) {
			switch (ev.key) {
				case 'Up': // For IE/Edge
				case 'ArrowUp': {
					this.setState((state) => {
						let newIndex = state.indexOfPredSearchElem - 1;
						if (newIndex <= 0) {
							newIndex = autoSuggest.length;
						}
						return {
							indexOfPredSearchElem: newIndex,
						};
					});
					break;
				}
				case 'Down': // For IE/Edge
				case 'ArrowDown': {
					this.setState((state) => {
						let newIndex = state.indexOfPredSearchElem;
						if (newIndex > autoSuggest.length - 1) {
							newIndex = 0;
						}
						return {
							indexOfPredSearchElem: newIndex + 1,
						};
					});
					break;
				}
				case 'Esc': // For IE/Edge
				case 'Escape': {
					this.props.togglePredSearch();
					break;
				}
				case 'Enter': {
					if (this.state.indexOfPredSearchElem === -1) {
						this.props.handleKeyUp(ev);
					} else {
						let finalList = this.getAutoList();
						this.props.handleSubmit(
							finalList[this.state.indexOfPredSearchElem - 1]
						);
						this.props.togglePredSearch();
						this.setState({
							indexOfPredSearchElem: -1,
						});
					}

					break;
				}
				case 'Backspace':
				case 'Delete': {
					if (!ev.target.value) this.props.togglePredSearch();
				}
			}
		} else {
			if (
				(window.innerWidth < 992 || window.screen.width < 992) &&
				ev.keyCode !== 13
			) {
				document
					.querySelector('#chatInput')
					.addEventListener('input', (event) => {
						this.props.handleKeyUp(event);
					});
			} else {
				this.props.handleKeyUp(ev);
			}
		}
	};
	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside);
		if (this.props.enableGetInTouch) {
			this.props.changeScreen('getintouchscreen');
		}
		this.setState({
			showMenuIcon: this.props.persistantMenuEnabled === 'true' ? true : false,
		});
	}
	componentDidUpdate(prevProps: Props) {
		if (prevProps.chatInput !== this.props.chatInput) {
			this.setState({
				showInputList: true,
				showMenu: false,
				count: 0,
				indexOfPredSearchElem: -1,
			});
		}
	}
	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside);
	}
	getAutoList = () => {
		let list = [];
		let suggestions = this.props.suggestions.response
			? this.props.suggestions.response
			: {};
		let predLength: number;
		if (this.props.predSearchResponse.search) {
			if (this.props.predSearchResponse.search.length > 3) {
				predLength = 3;
			} else {
				predLength = this.props.predSearchResponse.search.length;
			}
		}
		if (suggestions.length > 0) {
			for (let i = 0; i < suggestions.length; i++) {
				list.push(suggestions[i].value);
			}
			list = list.filter((e) =>
				e.toLowerCase().includes(this.props.chatInput.toLowerCase())
			);
		} else if (this.props.predSearchToggle) {
			for (let i = 0; i < predLength; i++) {
				if (!list.includes(this.props.predSearchResponse.search[i].q)) {
					list.push(this.props.predSearchResponse.search[i].q);
				}
			}
		}
		return list;
	};
	handleClickOutside = (event: any) => {
		if (
			!this.state.showMenu &&
			!this.myRef.current &&
			this.myRef.current != null &&
			!this.myRef.current.contains(event.target)
		) {
			this.setState({
				showMenu: false,
				count: this.state.count - 1,
			});
		}
	};

	hideMenu = () => {
		this.setState({
			showMenu: false,
			showInputList: false,
			count: 0,
		});
	};

	showMenu = () => {
		this.setState({
			showMenu: true,
			showInputList: false,
			count: this.state.count + 1,
		});
	};

	changeCursor = (data: string, hoveredItem?: any, list?: any) => {
		if (data === 'in') {
			this.setState({
				isCursor: true,
				indexOfPredSearchElem: hoveredItem,
				sortedList: list,
			});
		} else {
			this.setState({
				isCursor: false,
			});
		}
	};
	onMouseDownHandler = () => {
		allowTabFocus = false;
		this.setState({
			addFocus: false,
		});
	};
	handleFocus = () => {
		setTimeout(() => {
			//if (allowTabFocus) {
			this.setState({
				addFocus: true,
			});
			//	}
		}, 0);
	};
	onBlurHandler = () => {
		this.setState({
			addFocus: false,
		});
	};
	render() {
		let foreground = styleVars.getPropertyValue('--usrMsgColor') || '#000000';
		let inputIconColor =
			styleVars.getPropertyValue('--inputBoxColor') || foreground;

		let persistantMenuData = this.props.persistantMenuData
			? typeof this.props.persistantMenuData === 'string'
				? JSON.parse(this.props.persistantMenuData)
				: this.props.persistantMenuData
			: [];
		let snackBarMessage = this.props.snackBarMessage
			? this.props.snackBarMessage
			: '';
		return (
			<ChatInputDIV
				selectedThem={this.props.selectedTheme}
				cartExist={this.props.cartExist}
				className={`ff-chatinput-block ${this.props.selectedTheme} ${this.props.currentScreen}`}>
				{this.props.currentScreen === 'homescreen' ||
				this.props.currentScreen === 'getintouchscreen' ||
				this.props.currentScreen === 'feedbackscreen' ? (
					<React.Fragment>
						<FooterHolder className='welcome-footer'>
							<div
								className={`${
									this.props.currentScreen === 'homescreen' ? 'selected' : ''
								}`}
								onClick={() => {
									this.props.changeScreen('homescreen');
								}}>
								{this.props.currentScreen === 'homescreen' ? (
									<HomeFilled
										fill={
											this.props.colorMode === 'dark'
												? `var(--selectedColor)`
												: this.props.colorScale[0]
										}
									/>
								) : (
									<Home
										fill={
											this.props.colorMode === 'dark'
												? `black`
												: this.props.colorScale[0]
										}
									/>
								)}
								<p
									className='ff-chatbot-caption'
									style={{
										color:
											this.props.colorMode === 'dark'
												? `${
														this.props.currentScreen === 'homescreen'
															? 'var(--selectedColor)'
															: ''
												  }`
												: this.props.colorScale[0],
										fontWeight:
											this.props.currentScreen === 'homescreen'
												? 600
												: 'normal',
									}}>
									Home
								</p>
							</div>
							<div
								className={`${
									this.props.currentScreen !== 'homescreen' &&
									this.props.currentScreen !== 'feedbackscreen' &&
									this.props.currentScreen !== 'getintouchscreen'
										? 'selected'
										: ''
								}`}
								onClick={() => {
									this.props.changeScreen('chatscreen');
								}}>
								<Chats
									fill={
										this.props.colorMode === 'dark'
											? `black`
											: this.props.colorScale[0]
									}
								/>

								<p
									className='ff-chatbot-caption'
									style={{
										color:
											this.props.colorMode === 'dark'
												? `black`
												: this.props.colorScale[0],
									}}>
									Chat
								</p>
							</div>
							<div
								style={{
									display: this.props.disableGetInTouch ? 'none' : 'flex',
								}}
								className={`${
									this.props.currentScreen === 'getintouchscreen'
										? 'selected'
										: ''
								}`}
								onClick={() => {
									this.props.changeScreen('getintouchscreen');
								}}>
								{this.props.currentScreen === 'getintouchscreen' ? (
									<GetinTouchFilled
										fill={
											this.props.colorMode === 'dark'
												? `var(--selectedColor)`
												: this.props.colorScale[0]
										}
									/>
								) : (
									<GetinTouch
										fill={
											this.props.colorMode === 'dark'
												? `black`
												: this.props.colorScale[0]
										}
									/>
								)}
								<p
									className='ff-chatbot-caption'
									style={{
										color:
											this.props.colorMode === 'dark'
												? `${
														this.props.currentScreen === 'getintouchscreen'
															? 'var(--selectedColor)'
															: 'black'
												  }`
												: this.props.colorScale[0],
										fontWeight:
											this.props.currentScreen === 'getintouchscreen'
												? 600
												: 'normal',
									}}>
									Get in Touch
								</p>
							</div>
							<div
								// className={`${this.props.currentScreen === 'feedbackscreen' ? 'selected' : ''}`}
								className='selected'
								onClick={() => {
									this.props.changeScreen(this.props.currentScreen, true);
								}}>
								<Feedback
									fill={
										this.props.colorMode === 'dark'
											? `black`
											: this.props.colorScale[0]
									}
								/>
								<p
									className='ff-chatbot-caption'
									style={{
										color:
											this.props.colorMode === 'dark'
												? `black`
												: this.props.colorScale[0],
									}}>
									Feedback
								</p>
							</div>
						</FooterHolder>

						<div
							className='ff-chatbot-timestamp'
							style={{
								display:
									this.props.selectedTheme === 'monaco' ||
									this.props.selectedTheme === 'E-commerce Chat'
										? 'none'
										: 'flex',
								justifyContent: 'center',
								margin: 0,
								marginBottom: '8px',
								height: '18px',
								color: 'rgba(0, 0, 0, 0.4)',
								width: 'calc(100vw - 24px)',
							}}
							onClick={() => {
								window.open('https://www.flyfish.ai/', '_blank');
							}}>
							<span className='ff-chatbot-body1'>Powered by</span>
							<svg
								style={{
									width: '45px',
									marginLeft: '5px',
									marginBottom: '1px',
								}}
								xmlns='http://www.w3.org/2000/svg'
								xmlnsXlink='http://www.w3.org/1999/xlink'
								id='Layer_2'
								data-name='Layer 2'
								viewBox='0 0 906.61 218.66'>
								<defs>
									<linearGradient
										id='linear-gradient'
										x1='418.76'
										y1='-4179.93'
										x2='632.69'
										y2='-4362'
										gradientTransform='translate(-3269.72 2745.37) rotate(45)'
										gradientUnits='userSpaceOnUse'>
										<stop offset='0' stopColor='#2c43ba' />
										<stop offset='.63' stopColor='#ab3791' />
										<stop offset='.81' stopColor='#cf3386' />
										<stop offset='1' stopColor='#e36ea4' />
									</linearGradient>
								</defs>
								<g id='Layer_1-2' data-name='Layer 1'>
									<g>
										<g>
											<path
												className='cls-1 flyfishlogo_class_001'
												d='m236.45,98.37L138.09,0l-72.68,72.68L25.69,32.96,0,58.65l39.72,39.72L1.47,136.62l27.05,27.05,38.25-38.25,71.32,71.32,98.37-98.37Zm-99.72,45.63l-44.27-44.27,45.63-45.63,44.27,44.27-45.63,45.63Z'
											/>
											<path
												className='cls-2 flyfishlogo_class_002'
												d='m281.93,24.62h96.13v24.32h-64.92v39.77h55.32v24.42h-55.32v58.97h-31.21V24.62Z'
											/>
											<path
												className='cls-2 flyfishlogo_class_002'
												d='m392.65,18.88h30.37v116.49c0,5.71.89,9.45,2.66,11.22,1.78,1.77,5.38,2.66,10.8,2.66h1.98v22.86c-3.13.7-7.72,1.04-13.78,1.04-11.55,0-19.78-2.85-24.69-8.56-4.91-5.71-7.36-14.23-7.36-25.57V18.88Z'
											/>
											<path
												className='cls-2 flyfishlogo_class_002'
												d='m469.45,64.18l24.43,82.46,23.9-82.46h31.84l-47.39,124.63c-2.02,5.15-4.16,9.6-6.42,13.36-2.26,3.76-4.94,6.89-8.04,9.39-3.1,2.51-6.63,4.31-10.59,5.43-3.97,1.11-8.66,1.67-14.09,1.67-2.85,0-5.31-.14-7.36-.42-2.05-.28-3.88-.56-5.48-.84v-22.86h5.74c3.83,0,6.99-.28,9.5-.84,2.51-.56,4.61-1.55,6.31-2.97,1.71-1.43,3.2-3.36,4.49-5.79,1.29-2.44,2.66-5.5,4.12-9.19l-43.42-111.58h32.46Z'
											/>
											<path
												className='cls-2 flyfishlogo_class_002'
												d='m559.63,64.18h15.97v-7.93c0-12.53,3.64-22.01,10.91-28.44,7.27-6.44,17.83-9.65,31.68-9.65,2.44,0,5.06.12,7.88.37,2.82.24,5.24.64,7.25,1.2v22.86h-4.91c-8,0-13.74,1.17-17.22,3.5-3.48,2.33-5.22,7.15-5.22,14.46v3.65h26.3v23.07h-26.3v84.86h-30.37v-84.86h-15.97v-23.07Z'
											/>
											<path
												className='cls-2 flyfishlogo_class_002'
												d='m653.45,64.18h30.37v107.93h-30.37v-107.93Z'
											/>
											<path
												className='cls-2 flyfishlogo_class_002'
												d='m711.55,141.32c4.73,3.27,9.83,5.83,15.29,7.67,5.46,1.84,10.84,2.77,16.13,2.77,5.01,0,8.94-.92,11.79-2.77,2.85-1.84,4.28-4.68,4.28-8.51,0-2.57-.75-4.68-2.24-6.32-1.5-1.64-4.12-3.01-7.88-4.12l-17.74-5.22c-8.84-2.57-15.57-6.31-20.2-11.22-4.63-4.91-6.94-11.33-6.94-19.26,0-5.43,1.08-10.18,3.24-14.25,2.16-4.07,5.11-7.5,8.87-10.28,3.76-2.78,8.28-4.89,13.57-6.32,5.29-1.43,11.06-2.14,17.33-2.14,7.72,0,15.2,1.04,22.44,3.13,7.24,2.09,13.36,4.98,18.37,8.66l-9.6,19.21c-8.84-5.29-18.09-7.93-27.77-7.93-5.01,0-8.94.82-11.79,2.45-2.85,1.64-4.28,4.12-4.28,7.46,0,2.71.85,4.8,2.56,6.26,1.71,1.46,3.98,2.64,6.84,3.55l16.28,4.91c9.95,2.99,17.31,6.87,22.08,11.64,4.77,4.77,7.15,11.22,7.15,19.36,0,10.86-4.02,19.38-12.06,25.57-8.04,6.19-19.05,9.29-33.04,9.29-8.84,0-16.96-1.25-24.37-3.76-7.41-2.51-13.97-6.05-19.68-10.65l11.38-19.21Z'
											/>
											<path
												className='cls-2 flyfishlogo_class_002'
												d='m806.51,18.88h30.37v58.97c3.27-5.15,7.72-9.19,13.36-12.11,5.64-2.92,12.18-4.38,19.62-4.38,12.25,0,21.43,3.46,27.56,10.39,6.12,6.92,9.19,16.86,9.19,29.8v70.56h-30.37v-68.37c0-12.53-5.57-18.82-16.7-18.89-6.82,0-12.3,2.47-16.44,7.41-4.14,4.94-6.21,11.83-6.21,20.67v59.18h-30.37V18.88Z'
											/>
											<rect
												className='cls-2 flyfishlogo_class_002'
												x='654.73'
												y='21.31'
												width='30.79'
												height='27.56'
												rx='13.78'
												ry='13.78'
											/>
										</g>
									</g>
								</g>
							</svg>
						</div>
					</React.Fragment>
				) : (
					<div
						className={
							this.props.formChatInputHidden
								? 'ff-form-input'
								: 'ff-chatInput-content'
						}>
						<ChatInputHolder
							// {...foreground}
							ref={this.myRef}
							className={`sf-chatinput-wrapper menu 
							${this.props.isChatInputDisabled ? 'action-disabled' : ''}
							`}
							style={{
								marginTop: this.props.isChatBodyVisible ? '' : '8px',
								display: this.props.isChatInputHidden ? 'none' : '',
							}}>
							{this.getAutoList().length > 0 &&
							this.state.showInputList &&
							this.props.chatInput !== '' ? (
								<ClickOutside
									identifier='.menu'
									callback={() => this.setState({ showInputList: false })}>
									<InputSuggestions
										assignPredSearchQues={this.props.assignPredSearchQues}
										indexOfPredSearchElem={this.state.indexOfPredSearchElem}
										changeCursor={this.changeCursor}
										predList={this.getAutoList()}
									/>
								</ClickOutside>
							) : null}

							<ClickOutside
								identifier='.persis-list,.accordian-menu'
								callback={() => this.setState({ showMenu: false })}>
								{this.state.showMenu && persistantMenuData.length > 0 ? (
									<PersistanceMenu
										persistantMenuData={persistantMenuData}
										isShowSameItemsMenuEnabled={
											this.props.isShowSameItemsMenuEnabled
										}
										hideMenu={this.hideMenu}
										voiceResponse={this.props.voiceResponse}
										changeInput={this.props.changeInput}
										changeScreen={this.props.changeScreen}
										submitchanges={this.props.submitchanges}
									/>
								) : null}
							</ClickOutside>
						</ChatInputHolder>
						{/* {snackBarMessage.length > 0 ? (
							<Snackbar content={snackBarMessage} />
						) : null} */}
						<InternationalizationContext.Consumer>
							{(val) => {
								const label = val.data.inputPlaceholder;
								const placeholder =
									this.props.selectedTheme === 'monaco' ||
									this.props.selectedTheme === 'E-commerce Chat'
										? 'Type your query'
										: this.props.channel === 'whatsapp'
										? 'Message'
										: label[val.currentLanguage] || label.en;
								return (
									<>
										<div
											role='textbox'
											aria-label={TString({
												labelName: 'typeYourMessageLabel',
												langCode: this.props.langCode,
												fromClass: true,
											})}
											id={'sfChatInputMain'}
											className={`sf-chatinput ${
												this.state.addFocus ? 'focused-input' : ''
											} ${
												this.getAutoList().length > 0 &&
												this.state.showInputList &&
												this.props.chatInput !== ''
													? 'preview-image-holder'
													: 'not-extend'
											} ${
												this.props.selectedTheme === 'monaco' ||
												this.props.selectedTheme === 'E-commerce Chat'
													? 'monaco'
													: ''
											}`}
											style={
												this.props.channel === 'whatsapp'
													? { width: '80%' }
													: {
															border:
																this.props.colorMode == 'dark'
																	? `1.5px solid rgba(0, 0, 0, 0.2)`
																	: '1.5px solid rgba(0, 0, 0, 0.2)',
													  }
											}>
											{this.state.showMenuIcon &&
											persistantMenuData.length > 0 &&
											this.props.channel !== 'whatsapp' ? (
												<div
													onClick={
														this.state.showMenu ? this.hideMenu : this.showMenu
													}
													className={`accordian-menu`}>
													<IconButton
														size={'normal'}
														title={TString({
															labelName: 'accordianLabel',
															langCode: this.props.langCode,
															fromClass: true,
														})}
														image={'accordian'}
														variant={'empty'}
														fill={inputIconColor}
														className='persis-icon'
														pressed={this.state.showMenu}
													/>
												</div>
											) : null}
											{this.props.channel === 'whatsapp' ? (
												<div className='smiley-for-input'>
													<SmileyIcon />
												</div>
											) : null}
											{/* <Input
												ref={this.inputRef}
												placeholder={placeholder}
												value={this.state.queryText}
												onChange={(ev: any) => {
													this.setState({
														queryText: ev.target.value,
													});
												}}
												onKeyDown={(ev: any) => {
													if (ev.keyCode === 13 || ev.key === 'Enter') {
														console.log('Enter', this.state.queryText);
														this.props.handleSubmit(this.state.queryText);
														ev.preventDefault();
													}
												}}
											/> */}
											<div
												contentEditable={true}
												ref={this.inputRef}
												style={{
													padding:
														this.props.channel === 'whatsapp' ? '12px' : '',
												}}
												id='chatInput'
												className={`styled-scroll body-text-1 ff-chatbot-body2`}
												placeholder={placeholder}
												onInput={(ev: any) => {
													this.props.handleInput(ev.target.textContent);
												}}
												onBlur={() => this.onBlurHandler()}
												onMouseDown={() => this.onMouseDownHandler()}
												onFocus={() => this.handleFocus()}
												// onKeyPress={event => this.keypress(event)}
												onKeyDown={(ev: any) => {
													if (ev.keyCode === 9) {
														allowTabFocus = true;
													}
													if (ev.keyCode === 13 || ev.key === 'Enter') {
														ev.preventDefault();
														ev.stopPropagation();
													}
												}}
												onKeyUp={(ev) => this.onKeyUpHandler(ev)}
												onDragOver={(ev) => ev.stopPropagation()}
												onDrop={(ev) =>
													this.onDropHandler(
														ev.dataTransfer.getData('text/plain')
													)
												}
											/>
											{this.props.channel === 'whatsapp' ? (
												<>
													<div className='file-icon'>
														<FileIcon />
													</div>
													<div className='change-language'>
														<IconButton
															fill={'#000'}
															variant={'empty'}
															size={'large'}
															onClick={this.props.toggleLang}
															image={'language'}
														/>
													</div>
												</>
											) : null}

											{/* Has a bug , 'Click Mic to start recording and the  startTyping to bring the send button and 
                  the remove all typed to see mic icon that you can't click because it is still recording
                  . After some time when recording pauses then you will be able to type
              ' */}

											{this.props.channel !== 'whatsapp' && (
												<CurrentLanguageContext.Consumer>
													{(val) => (
														<Mic
															{...this.props}
															getLoader={this.props.getLoader}
															isSpeech={this.props.isSpeech}
															handleSubmit={this.handleSubmit}
															stopSpeaking={this.props.stopSpeaking}
															handleInput={this.props.handleInput}
															toggleSpeakingFunctionality={
																this.props.toggleSpeakingFunctionality
															}
															foreground={inputIconColor}
															botId={this.props.botId}
															currentLanguageCode={val.languageCode}
														/>
													)}
												</CurrentLanguageContext.Consumer>
											)}
										</div>
										{this.props.selectedTheme !== 'monaco' &&
										this.props.selectedTheme !== 'E-commerce Chat' ? (
											<div
												className='feedback-copywrite'
												style={{
													display: 'flex',
													justifyContent:
														this.props.data.botName
															.toLowerCase()
															.indexOf('fractal') > -1
															? 'center'
															: 'space-between',
													cursor: 'pointer',
												}}>
												<p
													className='ff-chatbot-overline'
													style={{
														color: 'rgba(0, 0, 0, 0.4)',
														margin: '10px 14px 0px',
													}}
													onClick={() =>
														this.props.changeScreen(
															this.props.currentScreen,
															true
														)
													}>
													Give Feedback
												</p>
												{this.props.data.botName
													.toLowerCase()
													.indexOf('fractal') > -1 ? null : (
													<p
														className='ff-chatbot-overline'
														style={{
															color: 'rgba(0, 0, 0, 0.4)',
															margin: '10px 14px 0px',
															display: 'flex',
														}}
														onClick={() => {
															window.open('https://www.flyfish.ai/', '_blank');
														}}>
														<span>Powered by</span>{' '}
														<svg
															style={{ width: '40px', marginLeft: '5px' }}
															xmlns='http://www.w3.org/2000/svg'
															xmlnsXlink='http://www.w3.org/1999/xlink'
															id='Layer_2'
															data-name='Layer 2'
															viewBox='0 0 906.61 218.66'>
															<defs>
																<linearGradient
																	id='linear-gradient'
																	x1='418.76'
																	y1='-4179.93'
																	x2='632.69'
																	y2='-4362'
																	gradientTransform='translate(-3269.72 2745.37) rotate(45)'
																	gradientUnits='userSpaceOnUse'>
																	<stop offset='0' stopColor='#2c43ba' />
																	<stop offset='.63' stopColor='#ab3791' />
																	<stop offset='.81' stopColor='#cf3386' />
																	<stop offset='1' stopColor='#e36ea4' />
																</linearGradient>
															</defs>
															<g id='Layer_1-2' data-name='Layer 1'>
																<g>
																	<g>
																		<path
																			className='cls-1 flyfishlogo_class_001'
																			d='m236.45,98.37L138.09,0l-72.68,72.68L25.69,32.96,0,58.65l39.72,39.72L1.47,136.62l27.05,27.05,38.25-38.25,71.32,71.32,98.37-98.37Zm-99.72,45.63l-44.27-44.27,45.63-45.63,44.27,44.27-45.63,45.63Z'
																		/>
																		<path
																			className='cls-2 flyfishlogo_class_002'
																			d='m281.93,24.62h96.13v24.32h-64.92v39.77h55.32v24.42h-55.32v58.97h-31.21V24.62Z'
																		/>
																		<path
																			className='cls-2 flyfishlogo_class_002'
																			d='m392.65,18.88h30.37v116.49c0,5.71.89,9.45,2.66,11.22,1.78,1.77,5.38,2.66,10.8,2.66h1.98v22.86c-3.13.7-7.72,1.04-13.78,1.04-11.55,0-19.78-2.85-24.69-8.56-4.91-5.71-7.36-14.23-7.36-25.57V18.88Z'
																		/>
																		<path
																			className='cls-2 flyfishlogo_class_002'
																			d='m469.45,64.18l24.43,82.46,23.9-82.46h31.84l-47.39,124.63c-2.02,5.15-4.16,9.6-6.42,13.36-2.26,3.76-4.94,6.89-8.04,9.39-3.1,2.51-6.63,4.31-10.59,5.43-3.97,1.11-8.66,1.67-14.09,1.67-2.85,0-5.31-.14-7.36-.42-2.05-.28-3.88-.56-5.48-.84v-22.86h5.74c3.83,0,6.99-.28,9.5-.84,2.51-.56,4.61-1.55,6.31-2.97,1.71-1.43,3.2-3.36,4.49-5.79,1.29-2.44,2.66-5.5,4.12-9.19l-43.42-111.58h32.46Z'
																		/>
																		<path
																			className='cls-2 flyfishlogo_class_002'
																			d='m559.63,64.18h15.97v-7.93c0-12.53,3.64-22.01,10.91-28.44,7.27-6.44,17.83-9.65,31.68-9.65,2.44,0,5.06.12,7.88.37,2.82.24,5.24.64,7.25,1.2v22.86h-4.91c-8,0-13.74,1.17-17.22,3.5-3.48,2.33-5.22,7.15-5.22,14.46v3.65h26.3v23.07h-26.3v84.86h-30.37v-84.86h-15.97v-23.07Z'
																		/>
																		<path
																			className='cls-2 flyfishlogo_class_002'
																			d='m653.45,64.18h30.37v107.93h-30.37v-107.93Z'
																		/>
																		<path
																			className='cls-2 flyfishlogo_class_002'
																			d='m711.55,141.32c4.73,3.27,9.83,5.83,15.29,7.67,5.46,1.84,10.84,2.77,16.13,2.77,5.01,0,8.94-.92,11.79-2.77,2.85-1.84,4.28-4.68,4.28-8.51,0-2.57-.75-4.68-2.24-6.32-1.5-1.64-4.12-3.01-7.88-4.12l-17.74-5.22c-8.84-2.57-15.57-6.31-20.2-11.22-4.63-4.91-6.94-11.33-6.94-19.26,0-5.43,1.08-10.18,3.24-14.25,2.16-4.07,5.11-7.5,8.87-10.28,3.76-2.78,8.28-4.89,13.57-6.32,5.29-1.43,11.06-2.14,17.33-2.14,7.72,0,15.2,1.04,22.44,3.13,7.24,2.09,13.36,4.98,18.37,8.66l-9.6,19.21c-8.84-5.29-18.09-7.93-27.77-7.93-5.01,0-8.94.82-11.79,2.45-2.85,1.64-4.28,4.12-4.28,7.46,0,2.71.85,4.8,2.56,6.26,1.71,1.46,3.98,2.64,6.84,3.55l16.28,4.91c9.95,2.99,17.31,6.87,22.08,11.64,4.77,4.77,7.15,11.22,7.15,19.36,0,10.86-4.02,19.38-12.06,25.57-8.04,6.19-19.05,9.29-33.04,9.29-8.84,0-16.96-1.25-24.37-3.76-7.41-2.51-13.97-6.05-19.68-10.65l11.38-19.21Z'
																		/>
																		<path
																			className='cls-2 flyfishlogo_class_002'
																			d='m806.51,18.88h30.37v58.97c3.27-5.15,7.72-9.19,13.36-12.11,5.64-2.92,12.18-4.38,19.62-4.38,12.25,0,21.43,3.46,27.56,10.39,6.12,6.92,9.19,16.86,9.19,29.8v70.56h-30.37v-68.37c0-12.53-5.57-18.82-16.7-18.89-6.82,0-12.3,2.47-16.44,7.41-4.14,4.94-6.21,11.83-6.21,20.67v59.18h-30.37V18.88Z'
																		/>
																		<rect
																			className='cls-2 flyfishlogo_class_002'
																			x='654.73'
																			y='21.31'
																			width='30.79'
																			height='27.56'
																			rx='13.78'
																			ry='13.78'
																		/>
																	</g>
																	{/* <line
																className='cls-3 flyfishlogo_class_003'
																y1='205.54'
																x2='423.14'
																y2='205.54'
															/>
															<line
																className='cls-3 flyfishlogo_class_003'
																x1='520.94'
																y1='205.54'
																x2='906.61'
																y2='205.54'
															/> */}
																</g>
															</g>
														</svg>
													</p>
												)}
											</div>
										) : null}
									</>
								);
							}}
						</InternationalizationContext.Consumer>

						{this.props.channel === 'whatsapp' && (
							<CurrentLanguageContext.Consumer>
								{(val) => (
									<Mic
										{...this.props}
										getLoader={this.props.getLoader}
										isSpeech={this.props.isSpeech}
										handleSubmit={this.handleSubmit}
										stopSpeaking={this.props.stopSpeaking}
										handleInput={this.props.handleInput}
										toggleSpeakingFunctionality={
											this.props.toggleSpeakingFunctionality
										}
										foreground={inputIconColor}
										botId={this.props.botId}
										currentLanguageCode={val.languageCode}
										channel={this.props.channel}
									/>
								)}
							</CurrentLanguageContext.Consumer>
						)}
					</div>
				)}
				{(this.props.selectedTheme === 'monaco' ||
					this.props.selectedTheme === 'E-commerce Chat') &&
				this.props.cartExist ? (
					<svg
						onClick={() => this.props.updateMonacoCartStatus(true)}
						style={{ width: '20px' }}
						className='Icon Icon--cart-desktop'
						role='presentation'
						viewBox='0 0 19 23'>
						<path
							d='M0 22.985V5.995L2 6v.03l17-.014v16.968H0zm17-15H2v13h15v-13zm-5-2.882c0-2.04-.493-3.203-2.5-3.203-2 0-2.5 1.164-2.5 3.203v.912H5V4.647C5 1.19 7.274 0 9.5 0 11.517 0 14 1.354 14 4.647v1.368h-2v-.912z'
							fill='currentColor'></path>
					</svg>
				) : null}
			</ChatInputDIV>
		);
	}
}

export default ChatInput;
